import { render, staticRenderFns } from "./identifications-page.vue?vue&type=template&id=e49f4cdc&scoped=true"
import script from "./identifications-page.vue?vue&type=script&lang=ts"
export * from "./identifications-page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49f4cdc",
  null
  
)

export default component.exports